import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { Actions, Getters, Mutations, AlertMessageState } from '@/interfaces/store/alertMessage'
import { RootState } from '@/interfaces/store/root'
import AlertMessageOptions from '@/interfaces/alert-message-options'

export const state: AlertMessageState = {
  isAlertMessageActive: false,
  alertMessageOptions: undefined
}

export const getters: GetterTree<AlertMessageState, RootState> & Getters = {}
export const actions: ActionTree<AlertMessageState, RootState> & Actions = {
  onOpen({ commit }, options: AlertMessageOptions) {
    commit('updateAlertMessageOptions', options)
    commit('updateAlertMessageActive', true)
  },
  onClose({ commit }) {
    commit('updateAlertMessageActive', false)
  },
}

export const mutations: MutationTree<AlertMessageState> & Mutations = {
  updateAlertMessageActive(state: AlertMessageState, isAlertMessageActive: boolean) {
    state.isAlertMessageActive = isAlertMessageActive
  },
  updateAlertMessageOptions(state: AlertMessageState, alertMessageOptions: AlertMessageOptions) {
    state.alertMessageOptions = alertMessageOptions
  },
}

export const store: Module<AlertMessageState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
